export default {
  labels: {
    free_items: 'Articles gratuits',
    bogo: 'Un acheté, un offert',
    order_again: 'Commander à nouveau',
  },
};
